import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle, Package, ArrowRight, Home } from 'lucide-react';
import './OrderSuccess.css';

function OrderSuccess() {
  const location = useLocation();
  const { orderId, total, customerName, email } = location.state || {};

  if (!orderId) {
    return (
      <div className="order-success">
        <div className="success-card">
          <h2>No order found</h2>
          <Link to="/" className="btn btn-gold">Go Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="order-success">
      <div className="success-card">
        <div className="success-icon">
          <CheckCircle size={64} />
        </div>
        <h1>Order Confirmed!</h1>
        <p className="success-subtitle">Thank you, {customerName}. Your order has been placed successfully.</p>

        <div className="order-details">
          <div className="detail-row">
            <span>Order Number</span>
            <strong>#{orderId}</strong>
          </div>
          <div className="detail-row">
            <span>Total Paid</span>
            <strong>{total?.toFixed(2)} SAR</strong>
          </div>
          <div className="detail-row">
            <span>Confirmation sent to</span>
            <strong>{email}</strong>
          </div>
        </div>

        <div className="success-info">
          <Package size={20} />
          <p>Your order will be processed within 1-2 business days. You will receive a shipping confirmation email shortly.</p>
        </div>

        <div className="success-actions">
          <Link to="/collection" className="btn btn-gold">
            Continue Shopping <ArrowRight size={18} />
          </Link>
          <Link to="/" className="btn">
            <Home size={16} /> Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default OrderSuccess;
